import type {JobVariant} from './types';
import './types';
export const READ_BUNDLE = 'READ_BUNDLE';
export const CREATE_JOB = 'CREATE_JOB';
export const DELETE_JOB = 'DELETE_JOB';
export const READ_JOB = 'READ_JOB';
export const CREATE_GLOBAL_JOB = 'CREATE_GLOBAL_JOB';
export const READ_GLOBAL_JOB = 'READ_GLOBAL_JOB';
export const READ_JOB_SCHEDULE = 'READ_JOB_SCHEDULE';
export const UPDATE_JOB_SCHEDULE = 'UPDATE_JOB_SCHEDULE';
export const RAFI_DEVICE_STOCK_ENV_KEY = 'REACT_APP_RAFI_DEVICE_STOCK_ASSET_GROUP_UUID';
export const BLACKLISTED_TENANT_IDS = 'REACT_APP_BLACKLISTED_TENANT_UUIDS';
export const ADMIN_CREATE_TEST_IDS = {
	FORM: 'updatejobs-admin-create-form',
	VARIANTS: 'updatejobs-admin-create-variants',
	DETAILS: 'updatejobs-admin-create-details',
	BUNDLE_SELECT: 'updatejobs-admin-create-bundle-select',
	JOB_VARIANT: 'updatejobs-admin-create-bundle-job-variant-',
	DATE_SELECT: 'updatejobs-admin-create-date-select',
	DESCRIPTION_INPUT: 'updatejobs-admin-create-description-input'
};
export const ADMIN_LIST_TEST_IDS = {
	DETAILS_LINK: 'updatejobs-admin-list-',
	LIGHT_FW_ICON: 'updatejobs-admin-list-light-fw-icon-',
	BOX_FW_ICON: 'updatejobs-admin-list-box-fw-icon-',
	KISIO_FW_ICON: 'updatejobs-admin-list-kisIo-fw-icon-'
};
export const ADMIN_CREATE_JOB_VARIANT_CONFIGS: Record<string, JobVariant> = {
	boxBundleData: {
		key: 'boxBundleData',
		name: {
			id: 'properties.sBox',
			defaultValue: 'KIS.BOX'
		},
		bundle: undefined,
		version: undefined
	},
	lightBundleData: {
		key: 'lightBundleData',
		name: {
			id: 'properties.sLight',
			defaultValue: 'KIS.LIGHT'
		},
		bundle: undefined,
		version: undefined
	},
	ioBundleData: {
		key: 'ioBundleData',
		name: {
			id: 'properties.kisIo',
			defaultValue: 'KIS.IO'
		},
		bundle: undefined,
		version: undefined
	}
};
export const JOB_STATUS = {
	ACTIVE: 'ACTIVE',
	PENDING: 'PENDING',
	EXECUTED: 'EXECUTED'
};
export const ASSET_GROUP_DEFINITION = {
	WORKSPACE: 'Workspace',
	INVENTORY: 'Inventory'
};
